/* Retirar Carousel */
import React, { useCallback, useEffect, useRef, useState } from "react";

import HeaderTabs from "../../components/HeaderTabs";
import ScreenLoader from "../../components/ScreenLoader";

import { FormattedMessage } from "react-intl";
import CardsActives from "../../components/CardsActives";
import AsyncStorage from "@react-native-async-storage/async-storage";
import GoBackButton from "../../components/GoBackButton";

const MarketplaceCategories = ({ navigation }) => {
  const loading1 = true; // Define sua variável de loading1

  async function selectedCategory(id, name) {
    await AsyncStorage.setItem("id_category", id.toString());
    navigation.navigate("MarketplaceCategories", { categoryName: name });
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="marketplacecategories.titleMarketplace" />}
        subtitle={<FormattedMessage id="marketplacecategories.subtitulo" />}
      />
      <CardsActives selectedCategoryAction={selectedCategory} />
      <GoBackButton />
    </>
  );
};

export default MarketplaceCategories;
